import { Emitter } from "pixi-particles";
import { Culture } from "../Data/Culture";
import { NoteParticleSystem } from "./NoteParticleSystem";

export class CharNoteParticleSystem extends NoteParticleSystem {
    constructor(pCulture: Culture) {
        super(pCulture);

        this._emitter = new Emitter(this, this.getTexturesForCulture(pCulture), {
            alpha: {
                list: [
                    { value: 0, time: 0 },
                    { value: 1, time: 0.2 },
                    { value: 1, time: 0.8 },
                    { value: 0, time: 1 },
                ],
            },
            scale: {
                start: 0.1,
                end: 1,
                minimumScaleMultiplier: 1,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 20,
                end: 10,
                minimumSpeedMultiplier: 1,
            },
            acceleration: {
                x: -85,
                y: -50,
            },
            maxSpeed: 0,
            startRotation: {
                min: -90,
                max: -200,
            },
            noRotation: false,
            rotationSpeed: {
                min: -100,
                max: 100,
            },
            lifetime: {
                min: 1.8,
                max: 2,
            },
            blendMode: "normal",
            frequency: 0.1,
            emitterLifetime: -1,
            maxParticles: 1000,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "circle",
            spawnCircle: { x: 0, y: -25, r: 10 },
        });

        this.stopEmitting();
    }

    public startEmitting(): void {
        this._emitter.emit = true;
    }

    public updateAcceleration(pX: number, pY: number): void {
        this._emitter.acceleration.set(pX, pY);
    }
}
